import { createAction } from '@reduxjs/toolkit';

import type {
  CreateApiIntegrationOperationPayload,
  CreateApiIntegrationPayload,
  DeleteApiIntegrationOperationPayload,
  DeleteApiIntegrationPayload,
  UpdateApiIntegrationConfigPayload,
  UpdateApiIntegrationOperationPayload,
  UpdateApiIntegrationPayload,
} from '@polyai/stream/commands/handlers/api-integrations';

const PREFIX = 'apiIntegrations';

const createApiIntegration = createAction<CreateApiIntegrationPayload>(
  `${PREFIX}/createApiIntegration`,
);

const deleteApiIntegration = createAction<DeleteApiIntegrationPayload>(
  `${PREFIX}/deleteApiIntegration`,
);

const updateApiIntegration = createAction<UpdateApiIntegrationPayload>(
  `${PREFIX}/updateApiIntegration`,
);

const updateApiIntegrationConfig =
  createAction<UpdateApiIntegrationConfigPayload>(
    `${PREFIX}/updateApiIntegrationConfig`,
  );

const createApiIntegrationOperation =
  createAction<CreateApiIntegrationOperationPayload>(
    `${PREFIX}/createApiIntegrationOperation`,
  );

const updateApiIntegrationOperation =
  createAction<UpdateApiIntegrationOperationPayload>(
    `${PREFIX}/updateApiIntegrationOperation`,
  );

const deleteApiIntegrationOperation =
  createAction<DeleteApiIntegrationOperationPayload>(
    `${PREFIX}/deleteApiIntegrationOperation`,
  );

export {
  createApiIntegration,
  createApiIntegrationOperation,
  deleteApiIntegration,
  deleteApiIntegrationOperation,
  updateApiIntegration,
  updateApiIntegrationConfig,
  updateApiIntegrationOperation,
};
